"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenizationProvider = void 0;
const event_bus_1 = require("../utils/event-bus");
const credit_card_validation_1 = require("../utils/credit-card-validation");
const error_types_contants_1 = require("../constants/error-types.contants");
const event_types_constants_1 = require("../constants/event-types.constants");
const card_types_constants_1 = require("../constants/card-types.constants");
const dom_1 = require("../utils/dom");
class TokenizationProvider {
    constructor(isProduction, cardNumber, cvv, firstName, lastName, expirationDate) {
        this.isProduction = isProduction;
        this.cardNumber = cardNumber;
        this.cvv = cvv;
        this.firstName = firstName;
        this.lastName = lastName;
        this.expirationDate = expirationDate;
        this.dom = new dom_1.Dom();
        this.eventBus = event_bus_1.EventBus.getInstance();
        this.tokenManagerState = {
            [cardNumber.name]: this.getInitialState(),
            [cvv.name]: this.getInitialState(),
            [firstName.name]: this.getInitialState(),
            [lastName.name]: this.getInitialState(),
            [expirationDate.name]: this.getInitialState()
        };
    }
    createIsDebitInput(isDebit) {
        if (!this.isDebitInput) {
            this.isDebit = isDebit;
            this.isDebitInput = this.dom.createHTMLInputCheckbox({
                parentId: this.isDebit.elementId,
                name: this.isDebit.name
            });
            this.tokenManagerState[this.isDebit.name] = this.getInitialState(true, false);
            this.isDebitInput.addEventListener('change', () => {
                if (this.isDebit) {
                    this.tokenManagerState[this.isDebit.name].value = !!this.isDebitInput ? this.isDebitInput.checked : false;
                }
                this.notifyChangeState();
            });
        }
        this.notifyChangeState();
    }
    createDocumentOptionsInputs(documentValue, documentType) {
        if (!this.documentTypeSelect && !this.documentValueInput) {
            this.documentValue = documentValue;
            this.documentType = documentType;
            this.documentTypeSelect = this.dom.createHTMLInputSelect({
                parentId: documentType.elementId,
                name: documentType.name,
                options: documentType.options
            });
            this.documentValueInput = this.dom.createHTMLInputText({
                parentId: documentValue.elementId,
                placeholder: documentValue.placeholder,
                name: documentValue.name
            });
            this.tokenManagerState[this.documentType.name] = this.getInitialState(!!this.documentTypeSelect.value, this.documentTypeSelect.value || '');
            this.tokenManagerState[this.documentValue.name] = this.getInitialState();
            this.documentValueInput.addEventListener('input', () => this.onInputDocumentValue());
            this.documentValueInput.addEventListener('focusout', () => this.notifyFocusOut());
            this.documentValueInput.addEventListener('focusin', () => this.notifyFocusInElement(this.documentValue ? this.documentValue.name : ''));
            this.documentTypeSelect.addEventListener('change', () => this.onChangeDocumentTypeSelect());
            this.documentTypeSelect.addEventListener('focusout', () => this.notifyFocusOut());
            this.documentTypeSelect.addEventListener('focusin', () => this.notifyFocusInElement(this.documentTypeSelect ? this.documentTypeSelect.name : ''));
        }
        this.notifyChangeState();
    }
    createInputs() {
        this.firstNameInput = this.dom.createHTMLInputText({
            parentId: this.firstName.elementId,
            name: this.firstName.name,
            placeholder: this.firstName.placeholder
        });
        this.lastNameInput = this.dom.createHTMLInputText({
            parentId: this.lastName.elementId,
            name: this.lastName.name,
            placeholder: this.lastName.placeholder
        });
        this.expirationDateInput = this.dom.createHTMLInputText({
            parentId: this.expirationDate.elementId,
            name: this.expirationDate.name,
            placeholder: this.expirationDate.placeholder
        });
        this.startEventsListener();
    }
    startEventsListener() {
        // events for first name input
        this.firstNameInput.addEventListener('input', () => this.onInputFirstName());
        this.firstNameInput.addEventListener('focusout', () => this.notifyFocusOut());
        this.firstNameInput.addEventListener('focusin', () => this.notifyFocusInElement(this.firstName.name));
        // events for last name input
        this.lastNameInput.addEventListener('input', () => this.onInputLastName());
        this.lastNameInput.addEventListener('focusin', () => this.notifyFocusInElement(this.lastNameInput.name));
        this.lastNameInput.addEventListener('focusout', () => this.notifyFocusOut());
        // events for input expiration date
        this.expirationDateInput.addEventListener('keypress', (event) => this.onKeypressExpirationDate(event));
        this.expirationDateInput.addEventListener('keydown', (event) => this.onkeydownExpirationDate(event));
        this.expirationDateInput.addEventListener('paste', (event) => event.preventDefault());
        this.expirationDateInput.addEventListener('input', () => this.onInputExipirationDate());
        this.expirationDateInput.addEventListener('focusin', () => this.notifyFocusInElement(this.expirationDateInput.name));
        this.expirationDateInput.addEventListener('focusout', () => this.notifyFocusOut());
    }
    onInputDocumentValue() {
        var _a;
        if (this.documentValueInput && this.documentValue) {
            const value = this.documentValueInput.value;
            this.documentValueInput.value = credit_card_validation_1.CreditCardValidation.removeCharacteres(value);
            const newValue = this.documentValueInput.value;
            this.tokenManagerState[(_a = this.documentValue) === null || _a === void 0 ? void 0 : _a.name] = {
                error: credit_card_validation_1.CreditCardValidation.getDocumentMessage(newValue),
                isValid: credit_card_validation_1.CreditCardValidation.isValidDocumentValue(newValue),
                isFocused: true,
                value: newValue
            };
            this.notifyChangeState();
        }
    }
    onChangeDocumentTypeSelect() {
        var _a;
        if (this.documentTypeSelect && this.documentType) {
            const value = this.documentTypeSelect.value;
            this.tokenManagerState[(_a = this.documentType) === null || _a === void 0 ? void 0 : _a.name] = {
                error: credit_card_validation_1.CreditCardValidation.getDocumentMessage(value),
                isValid: credit_card_validation_1.CreditCardValidation.isValidDocumentValue(value),
                isFocused: true,
                value
            };
        }
    }
    onInputFirstName() {
        const value = this.firstNameInput.value;
        this.firstNameInput.value = credit_card_validation_1.CreditCardValidation.removeExpecialCharacters(value);
        const newValue = this.firstNameInput.value;
        this.tokenManagerState[this.firstName.name] = {
            error: credit_card_validation_1.CreditCardValidation.getFirstNameOrLastNameError(newValue),
            isValid: credit_card_validation_1.CreditCardValidation.isValidFirstNameOrLastNameValue(newValue),
            isFocused: true,
            value: newValue
        };
        this.notifyChangeState();
    }
    onInputLastName() {
        this.lastNameInput.value = credit_card_validation_1.CreditCardValidation.removeExpecialCharacters(this.lastNameInput.value);
        const newValue = this.lastNameInput.value;
        this.tokenManagerState[this.lastName.name] = {
            error: credit_card_validation_1.CreditCardValidation.getFirstNameOrLastNameError(newValue),
            isValid: credit_card_validation_1.CreditCardValidation.isValidFirstNameOrLastNameValue(newValue),
            isFocused: true,
            value: newValue
        };
        this.notifyChangeState();
    }
    onKeypressExpirationDate(event) {
        if (!credit_card_validation_1.CreditCardValidation.restrictNumeric(event.key) || credit_card_validation_1.CreditCardValidation.restrictExpiry(event.key, this.expirationDateInput)) {
            event.preventDefault();
        }
    }
    onInputExipirationDate() {
        const newValue = this.expirationDateInput.value;
        this.tokenManagerState[this.expirationDate.name] = {
            error: credit_card_validation_1.CreditCardValidation.getExpiryDateMessage(newValue),
            isValid: credit_card_validation_1.CreditCardValidation.isValidExpiryDate(newValue),
            isFocused: true,
            value: newValue
        };
        this.notifyChangeState();
    }
    onkeydownExpirationDate(event) {
        credit_card_validation_1.CreditCardValidation.formatExpiry(event, this.expirationDateInput);
    }
    notifyFocusOut() {
        Object.keys(this.tokenManagerState).forEach((key) => this.tokenManagerState[key].isFocused = false);
        this.notifyChangeState();
    }
    notifyFocusInElement(element) {
        this.tokenManagerState[element].isFocused = true;
        this.notifyChangeState();
    }
    notifyChangeState() {
        this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.INPUT_CHANGE, this.tokenManagerState);
    }
    notifyCardType(cardType) {
        this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.CARD_TYPE, { cardType: card_types_constants_1.CARD_TYPES[`${cardType}`] || card_types_constants_1.CARD_TYPES.default });
    }
    clearForm() {
        this.expirationDateInput.value = '';
        this.firstNameInput.value = '';
        this.lastNameInput.value = '';
        this.expirationDateInput.value = '';
        this.tokenManagerState = {
            [this.cardNumber.name]: this.getInitialState(),
            [this.cvv.name]: this.getInitialState(),
            [this.firstName.name]: this.getInitialState(),
            [this.lastName.name]: this.getInitialState(),
            [this.expirationDate.name]: this.getInitialState()
        };
        if (this.isDebitInput && this.isDebit) {
            this.isDebitInput = undefined;
            this.dom.deleteElementFromParent(this.isDebit.elementId);
            delete this.tokenManagerState[this.isDebit.name];
        }
        if (this.documentTypeSelect && this.documentType) {
            this.documentTypeSelect = undefined;
            this.dom.deleteElementFromParent(this.documentType.elementId);
            delete this.tokenManagerState[this.documentType.name];
        }
        if (this.documentValueInput && this.documentValue) {
            this.documentTypeSelect = undefined;
            this.dom.deleteElementFromParent(this.documentValue.elementId);
            delete this.tokenManagerState[this.documentValue.name];
        }
    }
    isValidData() {
        Object.keys(this.tokenManagerState).forEach((key) => {
            const { isValid, error } = this.tokenManagerState[key];
            if (!isValid && error_types_contants_1.ErrorTypes.EMPTY === error) {
                this.tokenManagerState[key].error = error_types_contants_1.ErrorTypes.IS_REQUIRED;
                this.tokenManagerState[key].isValid = false;
            }
        });
        return Object.keys(this.tokenManagerState).filter((key) => !this.tokenManagerState[key].isValid).length === 0;
    }
    getInitialState(isValid = false, value = '') {
        return {
            error: error_types_contants_1.ErrorTypes.EMPTY,
            isFocused: false,
            isValid,
            value
        };
    }
}
exports.TokenizationProvider = TokenizationProvider;
